import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AppState } from "@app/reducers";
import { CrudService, ModulesBasedApiSuffix, prepareRequiredHttpParams, RxjsService, setRequiredValidator } from "@app/shared";
import { loggedInUserData } from "@modules/others/auth.selectors";
import { UserLogin } from "@modules/others/models/others-module-models";
import { CorporateTrafficAddModel } from "@modules/panic-app/models/corporate-traffic.model";
import { PanicAppApiSuffixModels } from "@modules/panic-app/shared";
import { select, Store } from "@ngrx/store";


@Component({
  selector: "app-corporate-tariff-add-edit",
  templateUrl: "./corporate-tariff-add-edit.component.html"
})
export class CorporateTariffAddEditComponent implements OnInit {
  personalPanicTariffId: string
  invoicePeriodList = []
  statusList = []
  groupList = []
  tariffCreationForm: FormGroup
  loggedUser: UserLogin
  startDate = new Date()
  todayDate = new Date()
  primengTableConfigProperties: any = {
    tableCaption: "Tariff Creation",
    shouldShowBreadCrumb: false,
    selectedTabIndex: 0,
    breadCrumbItems: [{ displayName: 'Panic App', relativeRouterUrl: '' }, { displayName: 'Corporate Tariff Config', relativeRouterUrl: '/panic-app/corporate-tariff' }, {
      displayName: 'Add/Edit Tariff Creation'
    }],
    tableComponentConfigs: {
      tabsList: [
        {
          caption: 'Tariff Creation',
          enableBreadCrumb: true,
          enableAction: true,
        }]
    }
  }

  constructor(private rxjsService: RxjsService, private crudService: CrudService, private formBuilder: FormBuilder,
    private store: Store<AppState>, private router: Router, private activatedRoute: ActivatedRoute) {
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.loggedUser = userData;
    });

    this.statusList = [
      { id: true, displayName: "Active" },
      { id: false, displayName: "In-Active" },
    ]
    this.activatedRoute.queryParams.subscribe(param => {
      this.personalPanicTariffId = param['id']
    })
  }
  ngOnInit(): void {
    this.getInvoicePeriodDrodown()
    this.createTariffAddForm();
    this.getSubscriptionGroupDrodown()
    if (!this.personalPanicTariffId) {
      this.generateTariffCode()
    } else {
      this.getDetails()
    }
    this.tariffCreationForm.get('validFrom').valueChanges.subscribe(value => {
      if (value) {
        this.startDate = new Date(value);
      }
    })
  }

  createTariffAddForm(): void {
    let creditCodeFormModel = new CorporateTrafficAddModel();
    this.tariffCreationForm = this.formBuilder.group({});
    Object.keys(creditCodeFormModel).forEach((key) => {
      this.tariffCreationForm.addControl(key, (key == 'createdUserId' || key == 'modifiedUserId') ? new FormControl(this.loggedUser.userId) :
        new FormControl(creditCodeFormModel[key]));
    });
    this.tariffCreationForm = setRequiredValidator(this.tariffCreationForm, ["tariffCode", "tariffDescription", "billingIntervalId", "validFrom", "isActive","tariffGroupId"]);
  }

  getDetails() {
    this.crudService.get(ModulesBasedApiSuffix.PANIC_APP, PanicAppApiSuffixModels.TARIFF_DETAILS, undefined, false, prepareRequiredHttpParams({ personalpanictariffId: this.personalPanicTariffId })).subscribe(response => {
      if (response.isSuccess && response.statusCode == 200 && response.resources) {
        response.resources.validFrom = new Date(response.resources.validFrom)
        response.resources.validTill = new Date(response.resources.validTill)
        this.tariffCreationForm.patchValue(response.resources);
      }
      this.rxjsService.setGlobalLoaderProperty(false)
    })
  }


  generateTariffCode() {
    this.tariffCreationForm.get("tariffCode").setValue("Generating")
    this.crudService.get(ModulesBasedApiSuffix.PANIC_APP, PanicAppApiSuffixModels.TRAIFF_NO_AUTOGENERATED).subscribe(response => {
      if (response.isSuccess && response.statusCode == 200 && response.resources) {
        if (response?.resources?.tariffCode){
          this.tariffCreationForm.get("tariffCode").setValue(response?.resources?.tariffCode)
        }else{
          this.tariffCreationForm.get("tariffCode").setValue("")
        }
      }else{
        this.tariffCreationForm.get("tariffCode").setValue("")
      }
      this.rxjsService.setGlobalLoaderProperty(false)
    })
  }
  getInvoicePeriodDrodown() {
    this.crudService.dropdown(ModulesBasedApiSuffix.PANIC_APP, PanicAppApiSuffixModels.TRAIFF_INVOICE_PERIOD_DROPDOWN).subscribe(response => {
      if (response.isSuccess && response.statusCode == 200 && response.resources) {
        this.invoicePeriodList = response.resources
      }
      this.rxjsService.setGlobalLoaderProperty(false)
    })
  }
  getSubscriptionGroupDrodown() {
    this.crudService.dropdown(ModulesBasedApiSuffix.PANIC_APP, PanicAppApiSuffixModels.TARIFF_GROUP).subscribe(response => {
      if (response.isSuccess && response.statusCode == 200 && response.resources) {
        this.groupList = response.resources
      }
      this.rxjsService.setGlobalLoaderProperty(false)
    })
  }

  onSubmit() {
    if (this.tariffCreationForm.invalid) return "";

    let obj = this.tariffCreationForm.getRawValue();
    obj.validFrom = obj.validFrom ? obj.validFrom.toDateString() : ''
    obj.validTill = obj.validTill ? obj.validTill.toDateString() : ''
    this.crudService.create(ModulesBasedApiSuffix.PANIC_APP, PanicAppApiSuffixModels.TARIFF, obj).subscribe(response => {
      if (response.isSuccess && response.statusCode == 200) {
        this.goBack()
      }
    })
  }

  goBack() {
    this.router.navigate(['/panic-app/corporate-tariff']);
  }
}
